import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export function appBar(theme: Theme) {
  return {
    MuiAppBar: {
      styleOverrides: {
        root: {
          color: theme.components?.MuiAppBar?.defaultProps?.color,
          boxShadow: 'none',
        },
      },
    },
  };
}
